// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calc-selector {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
}

.calc-row .calc-selector {
    flex: 1 1 240px;
}

.select-button {
    padding: 1em 1.5em;
    color: black;
    display: flex;
    font-size: medium;
    transition: 0.25s;
}

.select-button:hover {
    background: #e2e2e2;
}

.selector-input {
    justify-content: space-between;
    align-items: center;
    font-weight: 400;
    border-radius: 10px;
    background: transparent;
    border: 1px solid #e2e2e2 !important;
    height: 58px;
}

.selector-input span {
    display: flex;
    flex: 1;
    justify-content: end;
}

.selector-input p {
    overflow: hidden;
    white-space: nowrap;
}

.calc-label {
    font-weight: 400;
    font-size: 12px;
    margin: 0;
}

.select-options {
    height: 0px;
    opacity: 0;
    position: absolute;
    top: 100%;
    display: flex;
    flex-direction: column;
    transition: ease-in-out 0.05s;
    gap: 16px;
    left: 0;
    width: 100%;
    border-radius: 10px;
    max-height: 280px;
    padding: 10px;
    z-index: -50;
}

.select-options.opened {
    margin-top: 10px;
    overflow: hidden;
    height: fit-content;
    opacity: 1;
    background: #FFF;
    z-index: 1000;
    -webkit-box-shadow: 1px 3px 15px 4px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: 1px 3px 15px 4px rgba(34, 60, 80, 0.2);
    box-shadow: 1px 3px 15px 4px rgba(34, 60, 80, 0.2);
}

.option-list {
    width: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column-reverse;
    gap: 0;
}

/* WebKit-браузеры */
.select-options.opened .option-list::-webkit-scrollbar {
    width: 6px;
    background: transparent; /* Трек остается прозрачным */
}

.select-options.opened .option-list::-webkit-scrollbar-thumb {
    background-color: rgb(196, 196, 196); /* Цвет ползунка */
    /* border-radius: 100px; */
    width: 100%;
    min-height: 128px !important;
}

.select-options.opened .option-list::-webkit-scrollbar-track {
    background: transparent; /* Трек остается прозрачным */
}

.select-button {
    padding: 1em 1em;
    font-weight: 400;
    justify-content: start;
    text-align: start;
    background: transparent;
    border-radius: 0;
    border-bottom: 1px solid #e2e2e2 !important;
    width: 100%;
}

.select-button.selected {
    background: #d9d9d9;
    font-weight: 500;
}

.calc-search {
    display: flex;
    gap: 8px;
    align-items: center;
    border-radius: 10px;
    position: sticky;
    height: 48px;
}

.search-icon {
    position: absolute;
    right: 16px;
}

@media screen and (max-width: 385px) {
    .selector-input p {
        max-width: 220px;
        overflow: hidden;
        white-space: nowrap;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/ui/selector/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,OAAO;IACP,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,SAAS;IACT,OAAO;IACP,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,0DAA0D;IAC1D,uDAAuD;IACvD,kDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,MAAM;AACV;;AAEA,oBAAoB;AACpB;IACI,UAAU;IACV,uBAAuB,EAAE,6BAA6B;AAC1D;;AAEA;IACI,oCAAoC,EAAE,kBAAkB;IACxD,0BAA0B;IAC1B,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,uBAAuB,EAAE,6BAA6B;AAC1D;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,2CAA2C;IAC3C,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;IACvB;;AAEJ","sourcesContent":[".calc-selector {\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n}\n\n.calc-row .calc-selector {\n    flex: 1 1 240px;\n}\n\n.select-button {\n    padding: 1em 1.5em;\n    color: black;\n    display: flex;\n    font-size: medium;\n    transition: 0.25s;\n}\n\n.select-button:hover {\n    background: #e2e2e2;\n}\n\n.selector-input {\n    justify-content: space-between;\n    align-items: center;\n    font-weight: 400;\n    border-radius: 10px;\n    background: transparent;\n    border: 1px solid #e2e2e2 !important;\n    height: 58px;\n}\n\n.selector-input span {\n    display: flex;\n    flex: 1;\n    justify-content: end;\n}\n\n.selector-input p {\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.calc-label {\n    font-weight: 400;\n    font-size: 12px;\n    margin: 0;\n}\n\n.select-options {\n    height: 0px;\n    opacity: 0;\n    position: absolute;\n    top: 100%;\n    display: flex;\n    flex-direction: column;\n    transition: ease-in-out 0.05s;\n    gap: 16px;\n    left: 0;\n    width: 100%;\n    border-radius: 10px;\n    max-height: 280px;\n    padding: 10px;\n    z-index: -50;\n}\n\n.select-options.opened {\n    margin-top: 10px;\n    overflow: hidden;\n    height: fit-content;\n    opacity: 1;\n    background: #FFF;\n    z-index: 1000;\n    -webkit-box-shadow: 1px 3px 15px 4px rgba(34, 60, 80, 0.2);\n    -moz-box-shadow: 1px 3px 15px 4px rgba(34, 60, 80, 0.2);\n    box-shadow: 1px 3px 15px 4px rgba(34, 60, 80, 0.2);\n}\n\n.option-list {\n    width: 100%;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column-reverse;\n    gap: 0;\n}\n\n/* WebKit-браузеры */\n.select-options.opened .option-list::-webkit-scrollbar {\n    width: 6px;\n    background: transparent; /* Трек остается прозрачным */\n}\n\n.select-options.opened .option-list::-webkit-scrollbar-thumb {\n    background-color: rgb(196, 196, 196); /* Цвет ползунка */\n    /* border-radius: 100px; */\n    width: 100%;\n    min-height: 128px !important;\n}\n\n.select-options.opened .option-list::-webkit-scrollbar-track {\n    background: transparent; /* Трек остается прозрачным */\n}\n\n.select-button {\n    padding: 1em 1em;\n    font-weight: 400;\n    justify-content: start;\n    text-align: start;\n    background: transparent;\n    border-radius: 0;\n    border-bottom: 1px solid #e2e2e2 !important;\n    width: 100%;\n}\n\n.select-button.selected {\n    background: #d9d9d9;\n    font-weight: 500;\n}\n\n.calc-search {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    border-radius: 10px;\n    position: sticky;\n    height: 48px;\n}\n\n.search-icon {\n    position: absolute;\n    right: 16px;\n}\n\n@media screen and (max-width: 385px) {\n    .selector-input p {\n        max-width: 220px;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
